import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import RequestsContainer from './RequestsContainer'


const RequestsRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><RequestsContainer></RequestsContainer></Provider>
}

RequestsRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default RequestsRoot
